import React, { useState, Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Keep this one
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

const App = lazy(() => import('./App'));
const Homepage = lazy(() => import('./pages/Homepage'));
const TermsAndConditions = lazy(() => import('./pages/TermsAndConditions'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const KeywordLandingPage = lazy(() => import('./pages/KeywordLandingPage'));

function RouteFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f9fbf8] text-gray-600">
      <span className="text-sm font-medium animate-pulse">Loading…</span>
    </div>
  );
}

function Root() {
  const [theme, setTheme] = useState(() => {
    if (typeof window === 'undefined') return 'light';
    try {
      const saved = localStorage.getItem('theme_pref');
      if (saved === 'light' || saved === 'dark') return saved;
    } catch (e) {}
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }
    return 'light';
  });
  return (
    <BrowserRouter>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Homepage theme="light" />} />
          <Route path="/app" element={<App theme={theme} setTheme={setTheme} />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/dual-language-book-of-mormon" element={<KeywordLandingPage slug="dual-language-book-of-mormon" />} />
          <Route path="/bilingual-scriptures" element={<KeywordLandingPage slug="bilingual-scriptures" />} />
          <Route path="/side-by-side-scriptures" element={<KeywordLandingPage slug="side-by-side-scriptures" />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

// Register service worker (PDF cache + other future offline features)
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

reportWebVitals();
